import { Category } from "Types"

export const externalLinks: Record<string, string> = {
    setupGuideVideo: "https://woocommerce-to-pipedrive.com/setup-guide/",
    getStarted: "https://woocommerce-to-pipedrive.com/get-started/",
    setupGuide: "https://woocommerce-to-pipedrive.com/guides-releases-tutorials/woocommerce-pipedrive-sync-guide/",
    homePage: "https://woocommerce-to-pipedrive.com/",
    contact: "https://woocommerce-to-pipedrive.com/contact",
}

export const unusableFieldsKey: string[] = [
    "id",
    "org_id",
    "people_count",
    "open_deals_count",
    "add_time",
    "update_time",
    "is_deleted",
    //deal
    "value",
    "stage_change_time",
    "last_activity_id",
    "next_activity_id",
    "add_time",
    "update_time",
    "last_incoming_mail_time",
    "last_outgoing_mail_time",
    "activities_count",
    

    // "won_time",
    "lost_time",
    "expected_close_date",
    "channel_id",
    "person_id", //Forcément l'utilisateur
    "local_won_date",
    "local_lost_date",
    "local_close_date",
    "close_time",
]

export const priorityFieldsKey: Record<Category, Array<string>> = {
    'person': [
        'name',
        'email',
        'owner_id',
    ],
    'organization': [
        'name',
        'owner_id',
        'address',
    ],
    'deal': [
        'title',
        'stage_id',
        'user_id',
        "status",
    ]
}

export const requiredFieldsKey: Record<Category, Record<string, Array<string>>> = {
    'deal': {
        'woocommerce_abandoned_cart': ['title']
    },
    'organization': {},
    'person': {},
}

export const defaultGuestPersonFiledsKey = [
    'first_name',
    'last_name',
    'email',
    'phone'
]



export type AdditionalFieldsData = {
    [category in Category]: {
        [key: string]: FieldData;
    };
};

interface FieldData {
    info?: JSX.Element;
    /**
     * Avertissement affiché uniquement quand l'option correspondante est sélectionnée.
     * La clé est l'id de l'option Pipedrive (ex: "deleted" pour le status d'un deal).
     */
    optionsWarning?: Record<string, JSX.Element>;
}

export const additionalFieldsData: AdditionalFieldsData = {
    'deal': {
        "status": {
            optionsWarning: {
                "deleted": <>
                    <strong>This status deletes the deal instead of updating it.</strong> It is moved
                    to the Pipedrive trash (restorable for 30 days), and the other fields configured
                    for this event are not applied.
                </>
            }
        }
        // "status": {
        //     "info": <>
        //         <div className="text-red-700">
        //             By default, the deal status will be<strong>'Open'</ strong > as long as the payment for the order has not been received.
        //             < br /> The status will be<strong>'Won'</ strong > when the order is confirmed(Order processing or Order completed) and<strong>'Lost'</ strong > when the order is lost (Order refunded, Order canceled).</div>
        //         < div className="m-t-10" >
        //             Of course, you can set custom values by enabling this field.
        //         </div>
        //     </>
        // }
    },
    'organization': {},
    'person': {},
}